import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const Target = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M16.25 9.02c.79 1.13 1.27 2.5 1.27 3.98 0 3.82-3.1 6.92-6.92 6.92S3.68 16.82 3.68 13s3.1-6.92 6.92-6.92c1.48 0 2.85.47 3.98 1.27l.98-.98a8.242 8.242 0 0 0-4.96-1.66c-4.58 0-8.3 3.72-8.3 8.3s3.72 8.3 8.3 8.3 8.3-3.72 8.3-8.3c0-1.86-.62-3.58-1.66-4.96l-.98.98-.01-.01Z" />
      <Path d="m10.77 13.17-.34-.34a.948.948 0 0 1 0-1.34l.95-.95c-.63-.2-1.34-.24-2.18.38-.74.54-1.24 1.36-1.17 2.27.09 1.27 1.1 2.28 2.37 2.38.91.07 1.74-.43 2.28-1.16.62-.85.58-1.55.38-2.19l-.95.95c-.37.37-.97.37-1.34 0Z" />
      <Path d="M14.31 10.96c.34.61.54 1.3.54 2.04 0 2.35-1.91 4.26-4.26 4.26-2.35 0-4.26-1.91-4.26-4.26 0-2.35 1.91-4.26 4.26-4.26.74 0 1.43.21 2.04.54l1.02-1.02c-.88-.57-1.93-.91-3.05-.91-3.11 0-5.64 2.53-5.64 5.64s2.53 5.64 5.64 5.64 5.64-2.53 5.64-5.64c0-1.13-.34-2.17-.91-3.05l-1.02 1.02Z" />
      <Path d="m21.88 4.49-1.93-.76-.25-2.02-1.94 1.44.18 1.53-7.14 7.14a.706.706 0 0 0 .5 1.2c.18 0 .36-.07.5-.21l7.2-7.2 1.02.39 1.87-1.52-.01.01Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default Target
